import * as api from "./omnimapApi";
import {FetchRetry} from "../function/common";
import {GetActionsOfMenu, InitiateProcess} from "./omnimapApi";
export default function standart() {}

export function FillTableAction(model, page_number, token) {
  return FetchRetry(()=>new Promise(function (resolve, reject) {
    api.FillTable(model, page_number, "token").then(function (data) {
      resolve(data);
    }).catch(reject)
  }));
}

export function FillFilterColumnsAction(model, data_id, token) {
  return FetchRetry(()=>new Promise(function (resolve, reject) {
    api.FillFilterColumns(model, data_id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function SearchFilterColumnsAction(model, key, search_id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.SearchFilterColumns(model, key, search_id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function GetTreeStructureAction(model, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetTreeStructure(model, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function AddFolderAction(model, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.AddFolder(model, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function DeleteFolderAction(model, folder_id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.DeleteFolder(model, folder_id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function SaveOrEditAction(model, method, id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.SaveOrEdit(model, method, id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function Delete(element, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.Delete(element, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function DeleteRelationAction(element, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.DeleteRelation(element, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function GetActionsOfRowAction(row_ids, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetActionsOfRow(row_ids, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function InstanceFlowActivityInputDataAction(row_ids, model, flowInstance) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.InstanceFlowActivityInputData(row_ids, model, flowInstance).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function AddParentFolderAction(model, child_id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.AddParentFolder(model, child_id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetColumnPropertiesAction(token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetColumnProperties(token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetEntityListAction(model, pageNr, pageSize, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetEntityList(model, pageNr, pageSize, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function OmnimapPost(model, pageNr, page_size, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.OmnimapPost(model, pageNr, page_size, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetRelationAction(id, page_number, page_size, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetRelation(id, page_number, page_size, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function DeleteContextAction(id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.DeleteContext(id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetRowOfDetailAction(id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetRowOfDetail(id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetContentDetailOfRowAction(id) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetContentDetailOfRow(id).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetActionsOfRowSingleAction(id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetActionsOfRowSingle(id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetRowOfActionDetailStartAction(id, stateId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetRowOfActionDetailStart(id, stateId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function InputDataActivityFlowAction(activity_id, instance_ids, model) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.InputDataActivityFlow(activity_id, instance_ids, model).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function StartActivityFlowAction(activity_id, instance_ids) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.StartActivityFlow(activity_id, instance_ids).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetRowOfActionDetailPostAction(id, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetRowOfActionDetailPost(id, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetActivityDefinitionAction(rowId, activiteId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetActivityDefinition(rowId, activiteId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetUsersAction(pageNumber, pageSize, filterKey, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetUsers(pageNumber, pageSize, filterKey, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetUserByRoleAction(pageNumber, pageSize, role, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetUserByRole(pageNumber, pageSize, role, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetDefinationStatusAction(model, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetDefinationStatus(model, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function InputdataPostAction(model, rowId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.InputdataPost(model, rowId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function ValidatePostAction(rowId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.ValidatePost(rowId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function StartActionActivityAction(model, rowId, startId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.StartActionActivity(model, rowId, startId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetAllUsersAction(
  page_number,
  page_size,
  filter,
  ownOrganisation,
  mandateOrganisation,
  role,
  token
) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api
      .GetAllUsers(
        page_number,
        page_size,
        filter,
        ownOrganisation,
        mandateOrganisation,
        role,
        token
      )
      .then(function (data) {
        resolve(data);
      }).catch(reject);
  }));
}
export function GetAllBySearchAction(model, page_size=30, page_number=1) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetAllBySearch(model, page_size, page_number).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function GetMediaListAction(model, rowId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetMediaList(model, rowId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function PostMediaAction(data, rowId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.PostMedia(data, rowId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function DeleteMediaAction(rowId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.DeleteMedia(rowId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetMediaAction(rowId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetMedia(rowId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function PatchMethodAction(data, rowId, validate, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.PatchMethod(data, rowId, validate, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetUserRolesAction(pageNumber, pageSize, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetUserRoles(pageNumber, pageSize, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function CreateUserAction(model, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.CreateUser(model, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function UserApiAction(userId, status, model, roles, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.UserApi(userId, status, model, roles, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetDataForMapAction(model, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetDataForMap(model, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetOrganisationsAction(pageNumber, pageSize, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetOrganisations(pageNumber, pageSize, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetActionListByRoleAction(referenceId, token) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetActionListByRole(referenceId, token).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetFreeFormatAction(referenceId, methodType, model) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetFreeFormat(referenceId, methodType, model).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetFreeFormatByIdAction(referenceId) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetFreeFormatById(referenceId).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetFreeFormatByIdActionForUserColumnOrder(userId, referenceId) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetFreeFormatByIdForUserColumnOrder(userId, referenceId).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GetUserProfileAction() {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetUserProfile().then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function GenericInstanceAction(model, method) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GenericInstance(model, method).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}
export function BulkImportAction(model, method) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.BulkImport(model, method).then(function (data) {
      resolve(data);
    }).catch((err) => reject(err));
  }));
}

export function InitiateProcessAction(model, endpoint) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.InitiateProcess(model, endpoint).then(function (data) {
      resolve(data);
    }).catch(reject);
  }));
}

export function GetActionsOfEndpointAction(endpoint) {
  return FetchRetry(()=>new Promise (function (resolve, reject) {
    api.GetActionsOfEndpoint(endpoint).then(function (data) {
      resolve(data['data']);
    }).catch(reject);
  }));
}